'use strict';

/*global createObjectCallBack*/
/*global services*/

function InternetConnectionManager() {
  this.online = false;

  this.init();
}

InternetConnectionManager.prototype = $.extend({}, {
  constructor: 'InternetConnectionManager',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    window.addEventListener('online',  createObjectCallBack(_this, 'setOnline'));
    window.addEventListener('offline', createObjectCallBack(_this, 'setOffline'));
  },

  //----------------------------------------------------------------------------

  setOnline: function setOnline() {
    var _this = this;

    _this.online = true;

    $('.k2-icon-logo').css({ color: '#b8ffb8' });
  },

  setOffline: function setOffline() {
    var _this = this;

    _this.online = false;

    $('.k2-icon-logo').css({ color: '#fb7474' });
  },

  isOnline: function isOnline() {
    //var _this = this;

    return true;

    //overime, zdali jsme online nebo ne
    //$.getSync(services.get('router').path('internet_connection_is_alive'), createObjectCallBack(_this, 'successIsAliveCheck'), createObjectCallBack(_this, 'failedIsAliveCheck'));

    //return _this.online;
  },

  successIsAliveCheck: function successIsAliveCheck(args) {
    var _this = this;

    var res = args[0];

    if (res.msg === 'SUCCESS') {
      _this.setOnline();
    } else {
      _this.setOffline();
    }

    return _this;
  },

  failedIsAliveCheck: function failedIsAliveCheck() {
    var _this = this;

    _this.setOffline();

    return _this;
  },

  viewOfflineWarning: function viewOfflineWarning() {
    var _this = this;

    services.get('notifications').viewErrorMessage(services.get('translator').trans('error.internet_connection'));

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    if (navigator.onLine) {
      _this.setOnline();
    } else {
      _this.setOffline();
    }

    _this.registerCallbacks();

    return _this;
  }
});
